module.exports = __webpack_public_path__ + "static/media/office-poster.0b53fe7c.jpg";